export default __webpack_public_path__ + "1ba0c593723eb2b2748def135750d2ef.png";